<div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card shadow-sm">
            <div class="card-header">
              <h3 class="card-title">{{ itemId ? 'Update Item' : ' Create Item' }} </h3>
            </div>
            <div class="card-body">
              <items-form
                [item]="item"
                (onSavedData)="onItemFormSavedData($event)"
              />
            </div>
          </div>
      </div>
      <!-- <div class="col-md-4">
        <items-authorisation [itemAuthorisation]="authorisation"
        (onSavedData)="onItemFormSavedData($event)"/>
      </div> -->
    </div>
    <div class="row mt-3">
        <div class="col-md-12">
            <notes-customers-form [customer]="itemNotes" [readonlyCustomerNotes]="false" [noteServiceMethod]="itemsService" [addNoteMethod]="'createNotes'" [deleteNoteMethod]="'deleteNotes'" [sectionAttribute]="'itemId'"/>
        </div>
    </div>
    
  </div>